import React from "react";
import classNames from "classnames";

interface PropAvatarProps {
  /** Thumbnail of the prop; falls back to an empty tile while it loads. */
  src?: string;
  size?: "28" | "36";
}

/** Square prop thumbnail on a soft tint, sized to sit next to an ActorAvatar. */
export default function PropAvatar({ src, size = "28" }: PropAvatarProps) {
  return (
    <div
      data-testid="prop-avatar"
      className={classNames(
        "flex-none box-border overflow-hidden bg-creator-surfaceHover",
        {
          "w-[28px] h-[28px] rounded-[6px]": size === "28",
          "w-[36px] h-[36px] rounded-[8px]": size === "36",
        }
      )}
    >
      {src && <img className="w-full h-full object-contain p-[2px] box-border" src={src} alt="" />}
    </div>
  );
}
